/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdNameResultOfint } from './IdNameResultOfint';
import {
    IdNameResultOfintFromJSON,
    IdNameResultOfintFromJSONTyped,
    IdNameResultOfintToJSON,
    IdNameResultOfintToJSONTyped,
} from './IdNameResultOfint';
import type { UserTaskStatus } from './UserTaskStatus';
import {
    UserTaskStatusFromJSON,
    UserTaskStatusFromJSONTyped,
    UserTaskStatusToJSON,
    UserTaskStatusToJSONTyped,
} from './UserTaskStatus';

/**
 * 
 * @export
 * @interface GetUserTaskResponse
 */
export interface GetUserTaskResponse {
    /**
     * 
     * @type {string}
     * @memberof GetUserTaskResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserTaskResponse
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserTaskResponse
     */
    description: string | null;
    /**
     * 
     * @type {UserTaskStatus}
     * @memberof GetUserTaskResponse
     */
    status: UserTaskStatus;
    /**
     * 
     * @type {Date}
     * @memberof GetUserTaskResponse
     */
    dueAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserTaskResponse
     */
    sourceModule: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserTaskResponse
     */
    sourceReference: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetUserTaskResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetUserTaskResponse
     */
    updatedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetUserTaskResponse
     */
    completedAt: Date | null;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof GetUserTaskResponse
     */
    assigneeUser: IdNameResultOfint;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof GetUserTaskResponse
     */
    createdByUser: IdNameResultOfint | null;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof GetUserTaskResponse
     */
    completedByUser: IdNameResultOfint | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserTaskResponse
     */
    isOverdue: boolean;
}



/**
 * Check if a given object implements the GetUserTaskResponse interface.
 */
export function instanceOfGetUserTaskResponse(value: object): value is GetUserTaskResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('dueAt' in value) || value['dueAt'] === undefined) return false;
    if (!('sourceModule' in value) || value['sourceModule'] === undefined) return false;
    if (!('sourceReference' in value) || value['sourceReference'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('completedAt' in value) || value['completedAt'] === undefined) return false;
    if (!('assigneeUser' in value) || value['assigneeUser'] === undefined) return false;
    if (!('createdByUser' in value) || value['createdByUser'] === undefined) return false;
    if (!('completedByUser' in value) || value['completedByUser'] === undefined) return false;
    if (!('isOverdue' in value) || value['isOverdue'] === undefined) return false;
    return true;
}

export function GetUserTaskResponseFromJSON(json: any): GetUserTaskResponse {
    return GetUserTaskResponseFromJSONTyped(json, false);
}

export function GetUserTaskResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserTaskResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'description': json['description'],
        'status': UserTaskStatusFromJSON(json['status']),
        'dueAt': (json['dueAt'] == null ? null : new Date(json['dueAt'])),
        'sourceModule': json['sourceModule'],
        'sourceReference': json['sourceReference'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
        'completedAt': (json['completedAt'] == null ? null : new Date(json['completedAt'])),
        'assigneeUser': IdNameResultOfintFromJSON(json['assigneeUser']),
        'createdByUser': IdNameResultOfintFromJSON(json['createdByUser']),
        'completedByUser': IdNameResultOfintFromJSON(json['completedByUser']),
        'isOverdue': json['isOverdue'],
    };
}

export function GetUserTaskResponseToJSON(json: any): GetUserTaskResponse {
    return GetUserTaskResponseToJSONTyped(json, false);
}

export function GetUserTaskResponseToJSONTyped(value?: GetUserTaskResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'description': value['description'],
        'status': UserTaskStatusToJSON(value['status']),
        'dueAt': value['dueAt'] == null ? value['dueAt'] : value['dueAt'].toISOString(),
        'sourceModule': value['sourceModule'],
        'sourceReference': value['sourceReference'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'completedAt': value['completedAt'] == null ? value['completedAt'] : value['completedAt'].toISOString(),
        'assigneeUser': IdNameResultOfintToJSON(value['assigneeUser']),
        'createdByUser': IdNameResultOfintToJSON(value['createdByUser']),
        'completedByUser': IdNameResultOfintToJSON(value['completedByUser']),
        'isOverdue': value['isOverdue'],
    };
}

